import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography } from 'web-library';

import { makeStyles } from 'tss-react/mui';
import { Control, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SubjectPaperDataTable from './SubjectPaperDataTable';
import {
  AccessArrangementRequestData,
  AccessArrangementRequestDetail,
  SubjectPaper
} from './AccessArrangementRequestModels';

const useStyles = makeStyles()((theme) =>
({
  subTitle: {
    color: theme.color.text.textHeader,
  },
  spaceBottom: {
    marginBottom: theme.spacing(3),
  },
}));

interface ModalContentProps {
  subjectPapers: SubjectPaper[];
  accessArrangementRequestDetail: AccessArrangementRequestDetail;
  control: Control<AccessArrangementRequestData>;
  register: (Ref: any) => void;
  setValue: UseFormSetValue<AccessArrangementRequestData>;
  getSelectedSubjectPapers: (selectedSubjectPapers: SubjectPaper[]) => void;
}

const EditRequestModalContent = ({
  subjectPapers,
  accessArrangementRequestDetail,
  control,
  register,
  setValue,
  getSelectedSubjectPapers,
}: ModalContentProps) => {
  const [selectedSubjectPapers, setSelectedSubjectPapers] = useState<SubjectPaper[]>();

  const { t } = useTranslation();
  const { classes } = useStyles();

  useEffect(() => {

    const {
      uuid: detailUuid,
      accessArrangementType,
      subjectPapers: selectedSubjectPapersData,
    } = accessArrangementRequestDetail;

    setValue('uuid', detailUuid);
    setValue('requestTypeUuid', accessArrangementType.iexamsCode);

    const selectedPapers: SubjectPaper[] = [];

    Object.values(selectedSubjectPapersData).forEach((subjectPaper) =>
      Object.values(subjectPaper).forEach((papers) =>
        papers.forEach(({ examRegistrationDetailUuid, paperUuid, isDraft, dropped }) =>
          selectedPapers.push({
            examRegistrationDetailUuid,
            paperUuid,
            isDraft,
            dropped,
          })
        )
      )
    );

    setSelectedSubjectPapers(selectedPapers);
    getSelectedSubjectPapers(selectedPapers);
  }, [accessArrangementRequestDetail, setValue, register, getSelectedSubjectPapers]);

  return (
    <>
      <Typography className={`${classes.subTitle} ${classes.spaceBottom}`} variant="h4">
        {t('accessArrangement->>AccessArrangementRequest.Edit.ModeOfAssessment')}
      </Typography>
      <Typography className={classes.spaceBottom} variant="body1">
        {accessArrangementRequestDetail.modeOfAssessment.description}
      </Typography>

      <Typography className={`${classes.subTitle} ${classes.spaceBottom}`} variant="h4">
        {t('accessArrangement->>AccessArrangementRequest.Edit.AccessArrangementRequestType')}
      </Typography>
      <Typography className={classes.spaceBottom} variant="body1">
        {accessArrangementRequestDetail.accessArrangementType.description}
      </Typography>

      {accessArrangementRequestDetail.remarks && (
        <>
          <Typography
            className={`${classes.subTitle} ${classes.spaceBottom}`}
            variant="h4"
            color="primary"
          >
            {t('accessArrangement->>AccessArrangementRequest.Remarks')}
          </Typography>
          <Typography className={classes.spaceBottom} variant="body1">
            {accessArrangementRequestDetail.remarks}
          </Typography>
        </>
      )}

      <Divider />

      <Typography className={classes.spaceBottom} variant="h3">
        {t('accessArrangement->>AccessArrangementRequest.SubjectAndPaper')}
      </Typography>
      <Typography className={classes.spaceBottom} variant="body1">
        {t('accessArrangement->>AccessArrangementRequest.SubjectAndPaperDescription')}
      </Typography>

      <Box className={classes.spaceBottom}>
        <SubjectPaperDataTable
          control={control}
          setValue={setValue}
          subjectPapersData={subjectPapers}
          selectedSubjectPapers={selectedSubjectPapers}
        />
      </Box>
    </>
  );
};

export default EditRequestModalContent;
